import { FunctionsHttpError } from '@supabase/supabase-js';

/**
 * Εξάγει το μήνυμα σφάλματος από οποιοδήποτε thrown value.
 * Καλύπτει PostgrestError (supabase-js), Error, και οποιοδήποτε object με .message.
 */
export function getErrorMessage(e: unknown, fallback = 'Κάτι πήγε στραβά. Δοκίμασε ξανά.'): string {
  return (e as any)?.message || fallback;
}

/** Διαβάζει το μήνυμα σφάλματος ({error}) που επέστρεψε μια Edge Function. */
export async function extractFunctionError(error: unknown, fallback: string): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const body = await error.context.json();
      if (body?.error) return String(body.error);
    } catch {
      // αγνόησε — πέφτουμε στο γενικό μήνυμα
    }
  }
  return getErrorMessage(error, fallback);
}
